import { useEffect, useState } from "react";
import AuthNavComponent from "../module/auth/AuthNav";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faUpload } from "@fortawesome/free-solid-svg-icons";
import CleanerPersonalInfo from "./CleanerPersonalInfo";
// import CleanerDocuments from "./CleanerDocuments";
import CleanerReference from "./CleanerReference";
import CleanerEmployment from "./CleanerEmployment";
import CleanerTraining from "./CleanerTraining";
import CleanerMedicalCondition from "./CleanerMedicalCondition";
import CleanerPreferences from "./CleanerPreferences";
import { FormattedMessage } from "react-intl";
import JobType from "./JobType";
import Availability from "./Availability";
import { useSearchParams } from "react-router-dom";
import { getCleaner } from "sr/utils/api/cleaner/getCleaner";
import { getAvailability } from "sr/utils/api/cleaner/getAvailability";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { uploadFile } from "sr/utils/api/uploadFile";
import { validateFile } from "sr/helpers/functions/validateFile";
import { autofillCleaner } from "sr/utils/api/cleaner/autofillCleaner";
import { post } from "sr/utils/axios";
import { toast } from "react-toastify";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { Days } from "../company/work-order/component/Days";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { getEmployment } from "sr/utils/api/cleaner/getEmployment";
import { getReference } from "sr/utils/api/cleaner/getReference";
import { getJobType } from "sr/utils/api/cleaner/getJobType";
import { getTraining } from "sr/utils/api/cleaner/getTraining";
import { getPreferences } from "sr/utils/api/cleaner/getPreferences";
import { deleteEmployment } from "sr/utils/api/cleaner/deleteEmployment";
import { deleteReference } from "sr/utils/api/cleaner/deleteReference";
import { deleteJobType } from "sr/utils/api/cleaner/deleteJobType";
import { deleteTraining } from "sr/utils/api/cleaner/deleteTraining";
import { deletePreference } from "sr/utils/api/cleaner/deletePreference";
import { deleteAvailability } from "sr/utils/api/cleaner/deleteAvailability";
import { deleteClearerData } from "sr/utils/api/cleaner/deleteClearerData";

const RESUME_AUTOFILL_LIMIT = 3;

export default function CleanerProfile() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("PersonalInfo");
  const [refrences, setRefrences] = useState([{ name: "", expand: true }]);
  const [empHty, setEmpHty] = useState([{ name: "", expand: true }]);
  const [training, setTraining] = useState([{ name: "", expand: true }]);
  const [medicalCdn, setMedicalCdn] = useState([{ name: "", expand: true }]);
  const [latLng, setLatLng] = useState("");
  const [hasPersonalInfo, setHasPersonalInfo] = useState(false);
  const [hasAvailability, setHasAvailability] = useState(false);
  const [stepperIndex, setStepperIndex] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const [cleanerData, setCleanerData] = useState<any>();
  const [resumeUploadStatus, setResumeUploadStatus] = useState<
    "" | "uploaded" | "manual" | "filled"
  >("");
  const [resumeName, setResumeName] = useState("");
  const [resumeFileError, setResumeFileError] = useState("");
  const [resumeLoader, setResumeLoader] = useState<
    "" | "upload" | "autofill" | "clear"
  >("");
  const [resumeAutofillCount, setResumeAutofillCount] = useState(0);
  const tabParam = searchParams.get("tab");
  const [cleanerId, setCleanerId] = useState("");

  useEffect(() => {
    const cleanerId = getUserDetails()?.user_id;
    setCleanerId(cleanerId);
  }, []);

  const getResumeAutofillLimitKey = () => {
    const cleanerId = getUserDetails()?.user_id || "guest";
    return `cleaner_resume_autofill_count_${cleanerId}`;
  };

  const getStoredResumeAutofillCount = () => {
    const storedCount = Number(
      localStorage.getItem(getResumeAutofillLimitKey()),
    );
    return Number.isNaN(storedCount) ? 0 : storedCount;
  };

  const incrementResumeAutofillCount = () => {
    const nextCount = getStoredResumeAutofillCount() + 1;
    localStorage.setItem(getResumeAutofillLimitKey(), String(nextCount));
    setResumeAutofillCount(nextCount);
    return nextCount;
  };

  useEffect(() => {
    const currentTab = tabParam ? parseInt(tabParam, 10) : 0;

    setStepperIndex(currentTab);
  }, [tabParam]);
  useEffect(() => {
    setResumeAutofillCount(getStoredResumeAutofillCount());
  }, []);
  useEffect(() => {
    checkCleanerProfileStatus();
    navigator.geolocation.getCurrentPosition(
      function (position) {
        setLatLng(position.coords.latitude + "," + position.coords.longitude);
      },
      function (error) {
        console.error("Error Code = " + error.code + " - " + error.message);
      },
    );
  }, []);

  // const toggleReferenceSection = (index: number) => {
  //   let referenceList = refrences;
  //   referenceList[index].expand = !referenceList[index].expand;
  //   setRefrences([...referenceList]);
  // };

  // const toggleEmpHstySection = (index: number) => {
  //   let empHtyList = empHty;
  //   empHtyList[index].expand = !empHtyList[index].expand;
  //   setEmpHty([...empHtyList]);
  // };

  // const toggleTrainingSection = (index: number) => {
  //   let trainingList = training;
  //   trainingList[index].expand = !trainingList[index].expand;
  //   setTraining([...trainingList]);
  // };

  // const toggleMedicalConditionSection = (index: number) => {
  //   let medicalCndList = medicalCdn;
  //   medicalCndList[index].expand = !medicalCndList[index].expand;
  //   setMedicalCdn([...medicalCndList]);
  // };

  const checkCleanerProfileStatus = async () => {
    const userId = getUserDetails()?.user_id;
    if (!userId) return;

    try {
      const [cleanerRes, availabilityRes] = await Promise.all([
        getCleaner(new URLSearchParams({ id: userId })),
        getAvailability(new URLSearchParams({ cleaner_id: userId })),
      ]);

      if (
        cleanerRes?.success &&
        cleanerRes?.data &&
        cleanerRes.data.address &&
        !!cleanerRes.data.address.address_line_1
      ) {
        setCleanerData(cleanerRes?.data);
      }

      const personalInfoFilled =
        cleanerRes?.success &&
        cleanerRes?.data &&
        cleanerRes.data.address &&
        !!cleanerRes.data.address.address_line_1;
      const availabilityFilled =
        availabilityRes?.success &&
        Array.isArray(availabilityRes.data) &&
        availabilityRes.data.length > 0;

      setHasPersonalInfo(personalInfoFilled);
      setHasAvailability(availabilityFilled);
    } catch (error) {
      console.error("Error checking profile status:", error);
    }
  };

  const HandleStepper = (data) => {
    if (data !== stepperIndex) {
      checkCleanerProfileStatus();
      setSearchParams({ tab: data.toString() });
    }
  };

  const hasValue = (value) =>
    value !== undefined && value !== null && value !== "";

  const compactObject = (data) =>
    Object.entries(data).reduce((acc, [key, value]) => {
      if (hasValue(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});

  const normaliseAutofillResponse = (data) => data?.data || data || {};

  const deleteItemsById = async (
    items: any[] = [],
    deleteHandler: (params: any) => Promise<any>,
    mode: "query" | "body" | "jobType" = "query",
  ) => {
    const ids = items.map((item) => item?.id).filter(Boolean);

    if (!ids.length) return true;

    const results = await Promise.allSettled(
      ids.map((id) => {
        if (mode === "body") {
          return deleteHandler({ id });
        }

        if (mode === "jobType") {
          return deleteHandler({ id });
        }

        const queryParams = new URLSearchParams();
        queryParams.append("id", id);
        return deleteHandler(queryParams);
      }),
    );

    return results.every((item) => item.status === "fulfilled");
  };

  const clearAutofillSections = async (cleanerId: string) => {
    const [
      employmentRes,
      referenceRes,
      jobTypeRes,
      trainingRes,
      preferenceRes,
      availabilityRes,
    ] = await Promise.all([
      getEmployment(cleanerId, undefined),
      getReference(cleanerId, undefined),
      getJobType(cleanerId, undefined, 1, 1000),
      getTraining(cleanerId, undefined),
      getPreferences(cleanerId, undefined),
      getAvailability(new URLSearchParams({ cleaner_id: cleanerId })),
    ]);

    const clearResults = await Promise.allSettled([
      deleteItemsById(employmentRes?.data || [], deleteEmployment),
      deleteItemsById(referenceRes?.data || [], deleteReference),
      deleteItemsById(jobTypeRes?.data || [], deleteJobType, "jobType"),
      deleteItemsById(trainingRes?.data || [], deleteTraining, "body"),
      deleteItemsById(preferenceRes?.data || [], deletePreference),
      deleteItemsById(availabilityRes?.data || [], deleteAvailability),
    ]);

    return clearResults.every((item) => item.status === "fulfilled");
  };

  const saveAutofillData = async (autofillData) => {
    const cleanerId = getUserDetails()?.user_id;
    if (!cleanerId) return false;

    await clearAutofillSections(cleanerId);

    const requests: Promise<any>[] = [];

    (autofillData?.employment || []).forEach((item) => {
      if (!item?.job_title && !item?.company_name) return;

      requests.push(
        post("/cleaner/employment", {
          cleaner_id: cleanerId,
          job_title: item?.job_title || "",
          company_name: item?.company_name || "",
          company_location: item?.company_location || "",
          working_since_start: item?.working_since_from || "",
          working_since_end: item?.is_currently_employed
            ? ""
            : item?.working_since_to || "",
          currently_employed: !!item?.is_currently_employed,
        }),
      );
    });

    (autofillData?.reference || []).forEach((item) => {
      if (
        !item?.reference_first_name &&
        !item?.reference_last_name &&
        !item?.reference_email_address &&
        !item?.reference_mobile_number
      ) {
        return;
      }

      requests.push(
        post("/cleaner/reference", {
          cleaner_id: cleanerId,
          first_name: item?.reference_first_name || "",
          last_name: item?.reference_last_name || "",
          email: item?.reference_email_address || "",
          mobile_number: item?.reference_mobile_number || "",
          visible_to_employer: true,
        }),
      );
    });

    const jobTypes = (autofillData?.job_type || [])
      .filter((item) => item?.job_type)
      .map((item) => ({
        cleaner_id: cleanerId,
        job_type: item?.job_type,
        rate: item?.hourly_rate ?? 0,
        additional_information: "",
      }));

    if (jobTypes.length) {
      requests.push(post("/cleaner/jobtype", jobTypes));
    }

    (autofillData?.trainings || []).forEach((item) => {
      if (!item?.certification) return;

      requests.push(
        post("/cleaner/training", {
          cleaner_id: cleanerId,
          training: item?.certification,
          documentName: item?.certification,
          documentType: "training",
          date_attended: item?.date_received || "",
          description: item?.description || "",
        }),
      );
    });

    (autofillData?.certifications || []).forEach((item) => {
      if (!item?.certification) return;

      requests.push(
        post("/cleaner/training", {
          cleaner_id: cleanerId,
          training: item?.certification,
          documentName: item?.certification,
          documentType: "certification",
          date_attended: item?.date_received || "",
          description: item?.description || "",
        }),
      );
    });

    const preferences = autofillData?.preferences;
    if (
      preferences &&
      Object.values(preferences).some((value) => hasValue(value) && value !== 0)
    ) {
      requests.push(
        post(
          "/cleaner/preference",
          compactObject({
            cleaner_id: cleanerId,
            radius: preferences?.radius_in_miles,
            shift_type: preferences?.employment_type,
            min_hours: preferences?.min_hours_work_per_week,
            max_hours: preferences?.max_hours_work_per_week,
          }),
        ),
      );
    }

    const availability = Object.entries(
      autofillData?.availability || {},
    ).reduce((acc: any[], [day, value]: any) => {
      if (!value?.start_time || !value?.end_time) return acc;

      const matchedDay = Days.find(
        (item) => item.fullName.toLowerCase() === day.toLowerCase(),
      );

      if (matchedDay) {
        acc.push({
          day: matchedDay.fullName,
          start_time: value.start_time,
          end_time: value.end_time,
        });
      }

      return acc;
    }, []);

    if (availability.length) {
      requests.push(
        post("/cleaner/availability", {
          cleaner_id: cleanerId,
          availability,
        }),
      );
    }

    const results = await Promise.allSettled(requests);
    return results.every((item) => item.status === "fulfilled");
  };

  const handleResumeUpload = async (e: any) => {
    const file = e.target.files?.[0];
    const fileCheck = validateFile(file);

    setResumeFileError("");
    if (fileCheck !== true) {
      setResumeFileError(fileCheck);
      return;
    }

    const cleanerId = getUserDetails()?.user_id;
    if (!cleanerId) return;

    setResumeLoader("upload");
    const data = new FormData();
    data.append("cleaner_id", cleanerId);
    data.append("resume", file);

    const result = await uploadFile(data);
    setResumeLoader("");

    if (result?.success === true) {
      setResumeName(file?.name || "");
      setResumeUploadStatus("uploaded");
      SuccessMessage("API.SUCCESS.RESUME.UPLOAD");
    }

    e.target.value = "";
  };

  const handleResumeAutofill = async () => {
    const cleanerId = getUserDetails()?.user_id;
    if (!cleanerId) return;

    const currentCount = getStoredResumeAutofillCount();
    if (currentCount >= RESUME_AUTOFILL_LIMIT) {
      toast.error(
        "Can't use auto fill because you already hit the limit of three times.",
      );
      setResumeAutofillCount(currentCount);
      return;
    }

    setResumeLoader("autofill");
    const result = await autofillCleaner({ cleaner_id: cleanerId });

    if (!result || result?.success === false) {
      setResumeLoader("");
      if (result?.message || result?.error) {
        toast.error(result?.message || result?.error);
      }
      return;
    }

    const autofillData = normaliseAutofillResponse(result);

    if (!autofillData) {
      setResumeLoader("");
      return;
    }

    const saved = await saveAutofillData(autofillData);
    setResumeLoader("");

    if (saved) {
      incrementResumeAutofillCount();
      setResumeUploadStatus("filled");
      toast.success("Resume details added to your profile.");
      checkCleanerProfileStatus();
    } else {
      toast.error(
        "Some resume details could not be saved. Please review your steps.",
      );
    }
  };

  const handleDeclineResumeAutofill = () => {
    setResumeUploadStatus("manual");
    setResumeFileError("");
  };

  const handleClearAutofilledData = async () => {
    const cleanerId = getUserDetails()?.user_id;
    if (!cleanerId) return;

    setResumeLoader("clear");
    await deleteClearerData({ cleaner_id: cleanerId }),
    await clearAutofillSections(cleanerId);
    setResumeLoader("");
    setResumeUploadStatus("manual");
    toast.success("Auto filled information cleared.");
    checkCleanerProfileStatus();
  };

  return (
    <>
      <AuthNavComponent></AuthNavComponent>
      {resumeLoader === "autofill" && (
        <LoaderFullScreen message="Auto filling your profile. Please don't reload or leave the page." />
      )}
      <main>
        <div className="lg:container lg:flex mx-auto lg:max-w-6xl lg:my-8 my-8 px-4 lg:px-0 block">
          <div className="lg:flex lg:flex-col lg:w-80 w-full block p-6 items-center bg-white border border-gray-border rounded-xl h-fit mb-4">
            <ol className="relative text-gray-500 border-l border-gray-800">
              <li
                onClick={() => HandleStepper(0)}
                className="mb-10 ml-6 cursor-pointer"
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 0 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 0 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.PERSONALINFO.TITLE"
                    defaultMessage="Personal Info"
                  />
                </h3>
              </li>
              {/* <li className="mb-10 ml-6">
                <span className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${stepperIndex >= 1 ? 'bg-green-500' : 'bg-gray-500'}`}>
                  <FontAwesomeIcon icon={stepperIndex > 1 ? faCheck : faCircle} className='text-white text-xs' />
                </span>
                <h3 className="font-medium leading-tight"><FormattedMessage id="CLEANER.REGISTER.DOCUMENTS.TITLE" defaultMessage="Documents" /></h3>
               
              </li> */}
              <li
                onClick={() => hasPersonalInfo && HandleStepper(1)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 1 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 1 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.EMPLOYMENT.TITLE"
                    defaultMessage="Employment"
                  />
                </h3>
              </li>
              <li
                onClick={() => hasPersonalInfo && HandleStepper(2)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 2 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 2 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.PROFILE.REFERENCE.TITLE"
                    defaultMessage="References"
                  />
                </h3>
              </li>

              <li
                onClick={() => hasPersonalInfo && HandleStepper(3)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 3 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 3 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TITLE"
                    defaultMessage="Trainings & Certifications"
                  />
                </h3>
              </li>
              <li
                onClick={() => hasPersonalInfo && HandleStepper(4)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 4 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 4 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.PREFERENCES.TITLE"
                    defaultMessage="Preferences"
                  />
                </h3>
              </li>
              {/* <li
                onClick={() => hasPersonalInfo && HandleStepper(5)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 6 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 5 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.MEDICALCONDITION.TITLE"
                    defaultMessage="Medical Condition"
                  />
                </h3>
              </li> */}
              <li
                onClick={() => hasPersonalInfo && HandleStepper(5)}
                className={`mb-10 ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 5 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 5 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.REGISTER.JOBTYPE.TITLE"
                    defaultMessage="Job Type"
                  />
                </h3>
              </li>
              <li
                onClick={() => hasPersonalInfo && HandleStepper(6)}
                className={`ml-6 ${
                  hasPersonalInfo ? "cursor-pointer" : "cursor-not-allowed"
                }`}
              >
                <span
                  className={`absolute flex items-center justify-center w-4 h-4 -left-2 p-2 rounded-full ring-4 ring-white ${
                    stepperIndex >= 6 ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  <FontAwesomeIcon
                    icon={stepperIndex > 6 ? faCheck : faCircle}
                    className="text-white text-xs"
                  />
                </span>
                <h3 className="font-medium leading-tight">
                  <FormattedMessage
                    id="CLEANER.PROFILE.AVAILABILITY.TITLE"
                    defaultMessage="Availability"
                  />
                </h3>
              </li>
            </ol>
          </div>
          <div className="lg:flex-1 lg:flex lg:flex-col block h-fit lg:mx-12 mx-auto p-6 bg-white border border-gray-border rounded-xl">
            {stepperIndex === 0 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.REGISTER.PERSONALINFO.TAB.TITLE"
                    defaultMessage="Personal Information"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.REGISTER.PERSONALINFO.TAB.DESCRIPTION"
                    defaultMessage="Personal information helps recuiters know about yourself"
                  />
                </h3>
                <div className="mt-5 rounded-lg border border-gray-200 bg-gray-50 p-4">
                  <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <div>
                      <div className="text-[15px] font-bold text-gray-900">
                        Resume auto fill
                      </div>
                      <div className="mt-1 text-[13px] font-medium text-gray-600">
                        Upload a resume to fill employment, references, job
                        type, trainings, preferences, and availability faster.
                      </div>
                      {resumeName && (
                        <div className="mt-2 text-[13px] font-semibold text-gray-800">
                          {resumeName}
                        </div>
                      )}
                      {resumeFileError && (
                        <div className="mt-2 text-[13px] font-semibold text-red-700">
                          {resumeFileError}
                        </div>
                      )}
                    </div>
                    <ContentWithSpinner loader={resumeLoader === "upload"}>
                      <label
                        htmlFor="registration-resume-upload"
                        className="inline-flex h-10 cursor-pointer items-center justify-center gap-2 rounded-md bg-[#0078ae] px-4 text-sm font-bold text-white hover:bg-navy"
                      >
                        <FontAwesomeIcon icon={faUpload} />
                        Upload resume
                      </label>
                      <input
                        id="registration-resume-upload"
                        type="file"
                        className="hidden"
                        accept=".doc,.docx,.rtf,.pdf"
                        onChange={handleResumeUpload}
                      />
                    </ContentWithSpinner>
                  </div>

                  {resumeUploadStatus === "uploaded" && (
                    <div className="mt-4 flex flex-col gap-3 rounded-md border border-gray-200 bg-white p-3 md:flex-row md:items-center md:justify-between">
                      <div className="text-[14px] font-semibold text-gray-800">
                        Do you want to auto fill your profile from this resume?
                      </div>
                      <div className="flex gap-2">
                        <button
                          type="button"
                          className="rounded-md border border-gray-300 px-4 py-2 text-sm font-bold text-gray-700 hover:bg-gray-100"
                          onClick={handleDeclineResumeAutofill}
                          disabled={resumeLoader === "autofill"}
                        >
                          No
                        </button>
                        <button
                          type="button"
                          className="rounded-md bg-[#ff39b3] px-4 py-2 text-sm font-bold text-white hover:bg-navy disabled:opacity-70"
                          onClick={handleResumeAutofill}
                          disabled={resumeLoader === "autofill"}
                        >
                          {resumeLoader === "autofill"
                            ? "Auto filling..."
                            : `Yes, auto fill (${resumeAutofillCount}/${RESUME_AUTOFILL_LIMIT})`}
                        </button>
                      </div>
                    </div>
                  )}

                  {resumeUploadStatus === "manual" && (
                    <div className="mt-3 text-[13px] font-semibold text-gray-600">
                      No problem. You can continue filling each step manually.
                    </div>
                  )}

                  {resumeUploadStatus === "filled" && (
                    <div className="mt-3 flex flex-col gap-3 rounded-md border border-green-100 bg-white p-3 md:flex-row md:items-center md:justify-between">
                      <div className="text-[13px] font-semibold text-green-700">
                        Resume details were added. Please review each step
                        before finishing registration.
                      </div>
                      <button
                        type="button"
                        className="rounded-md border border-red-200 px-4 py-2 text-sm font-bold text-red-700 hover:bg-red-50 disabled:opacity-70"
                        onClick={handleClearAutofilledData}
                        disabled={resumeLoader === "clear"}
                      >
                        {resumeLoader === "clear"
                          ? "Clearing..."
                          : "Clear auto filled info"}
                      </button>
                    </div>
                  )}
                </div>
                <div className="w-full">
                  <CleanerPersonalInfo
                    cleanerDetails={cleanerData}
                    HandleStepper={HandleStepper}
                  ></CleanerPersonalInfo>
                </div>
              </div>
            )}

            {stepperIndex === 1 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.PROFILE.EMLOYMENT.TITLE"
                    defaultMessage="Employment"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.PROFILE.EMLOYMENT.TEXT"
                    defaultMessage="Employment details helps recuiters understand your background"
                  />
                </h3>
                <div className="w-full">
                  <CleanerEmployment
                    HandleStepper={HandleStepper}
                  ></CleanerEmployment>
                </div>
              </div>
            )}

            {stepperIndex === 2 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.PROFILE.REFERENCE.TITLE"
                    defaultMessage="Reference"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.PROFILE.REFERENCE.TEXT"
                    defaultMessage="Add references to help recruiters learn more about your work experience."
                  />
                </h3>
                <div className="w-full">
                  <CleanerReference
                    HandleStepper={HandleStepper}
                  ></CleanerReference>
                </div>
              </div>
            )}

            {stepperIndex === 3 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TAB.TITLE"
                    defaultMessage="Add Trainings & Certifications"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.REGISTER.TRAINING_CERTIFICATIONS.TEXT"
                    defaultMessage="Please enter any recent trainings or certifications you have attended or received."
                  />
                </h3>
                <div className="w-full">
                  <CleanerTraining
                    HandleStepper={HandleStepper}
                  ></CleanerTraining>
                </div>
              </div>
            )}

            {stepperIndex === 4 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.REGISTER.PREFERENCES.TAB.TITLE"
                    defaultMessage="Add your preferences"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.PROFILE.PREFERENCES.TEXT"
                    defaultMessage="preferences details helps recuiters understand your preferences"
                  />
                </h3>
                <div className="w-full">
                  <CleanerPreferences
                    HandleStepper={HandleStepper}
                  ></CleanerPreferences>
                </div>
              </div>
            )}

            {/* {stepperIndex === 5 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.REGISTER.MEDICAL.TAB.TEXT"
                    defaultMessage="Add your recent medical condition"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.REGISTER.MEDICAL.TAB.TITLE"
                    defaultMessage="Add your recent medical condition"
                  />
                </h3>
                <div className="w-full">
                  <CleanerMedicalCondition
                    HandleStepper={HandleStepper}
                  ></CleanerMedicalCondition>
                </div>
              </div>
            )} */}

            {stepperIndex === 5 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.REGISTER.JOBTYPE.TAB.TITLE"
                    defaultMessage="Add your Job Type"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.PROFILE.JOBTYPE.TEXT"
                    defaultMessage="Job Type details helps recuiters understand your Job Type"
                  />
                </h3>
                <div className="w-full">
                  <JobType HandleStepper={HandleStepper}></JobType>
                </div>
              </div>
            )}
            {stepperIndex === 6 && (
              <div>
                <h1 className=" text-xl">
                  <FormattedMessage
                    id="CLEANER.PROFILE.AVAILABILITY.TITLE"
                    defaultMessage="Availability"
                  />
                </h1>
                <h3 className=" text-md">
                  <FormattedMessage
                    id="CLEANER.PROFILE.AVAILABILITY.TEXT"
                    defaultMessage="preferences details helps recuiters understand your preferences"
                  />
                </h3>
                <div className="w-full">
                  <Availability id={cleanerId}></Availability>
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </>
  );
}
